import { NgZone, OnInit, Component } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router'
import { CookieService, MyOrderService, PackageService } from '../_services/index';

declare var $: any;
declare var google: any;
declare var jQuery: any;
declare var REP: any;
declare var gtag: Function;

@Component({
    moduleId: module.id,
    templateUrl: 'onholdp.component.html',
    styleUrls: ['onholdp.component.css']
})
export class OnholdComponentp implements OnInit {
    onHoldType: string;
    onHoldGeom: any;
    onHoldEmail: string;
    onHoldBound = [];
    errorInfo = "";
    confirmation = "";
    validationInfo = "";
    address: any = "";
    alternate_email: "";
    city: any = "";
    country: "";
    order_geometry: "";
    centroid: "";
    geometry: "";
    geometry_type: "";
    postalzip: "";
    project_num: "";
    provstate: "";
    site_name: "";
    savedGeoLayer: any;
    savedMultiGeoLayer = [];
    order_num: "";
    isLoading = false
    status: "";
    errormsg: "";
    latlng: ""
    provstate1: ""
    yes = true;
    Zoom: any
    popup = false;
    orderdetail: any
    dis_code_options: []
    constructor(private packageService: PackageService, private route: ActivatedRoute, private router: Router, private ngZone: NgZone, private cookieService: CookieService, private myOrderService: MyOrderService) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                // gtag('js', new Date());
                // gtag('config', 'UA-65756200-2');
            }
        });
    }

    ngOnInit() {
        this.getOrderData();
    }

    onumber: any = null
    customerId: any = ""
    token: any = null
    call_count = true
    // >>>>>> getOderData

    statuscheck2 = false

    limstate() {
        this.statuscheck2 = true
        if ((this.cookieService.getCookie("modifyGeometry")) && (this.cookieService.getCookie("modifyType"))) {

            this.onHoldGeom = this.cookieService.getCookie("modifyGeometry");
            this.onHoldType = this.cookieService.getCookie("modifyType");

            this.latlng = JSON.parse(this.onHoldGeom)[0][0].reverse()
        }
        else {
            this.savedata()
        }

        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'location': { 'lat': this.latlng[0], 'lng': this.latlng[1] } }, (results) => {
            this.ngZone.run(() => {
                let statedata = results[0];
                let res = statedata.address_components.filter(item => {
                    return item.types[0] == 'administrative_area_level_1'
                })
                let res1 = statedata.address_components.filter(item => {
                    return item.types[0] == 'country'
                })
                if (res1[0]["long_name"] == "Canada" || res[0]["long_name"] == "Mexico") {
                    this.yes = true
                    this.savedata()
                }
                else {
                    let s1 = res[0]["short_name"]
                    if (this.provstate == s1) {
                        this.yes = true
                        this.savedata()
                    }
                    else {
                        this.yes = false
                    }
                }
            })
        })
        this.statuscheck2 = false
    }

    geostat
    ins
    rush
    dis_code
    private onHoldCustomerId = "";

    private getCustomerIdFromOrderInfo(orderInfo: any): string {
        if (!orderInfo) return "";

        return orderInfo.CUSTOMER_ID || orderInfo.customerID || orderInfo.customerId || orderInfo.customerid || "";
    }

    private getOnholdCustomerId(): string {
        return this.onHoldCustomerId || this.cookieService.getCookie('customerID');
    }

    getOrderData() {
        this.route.queryParams.subscribe(res => {
            this.onumber = res.onumber
            this.token = res.token
            let inputJson = {
                "PROCEDURE": "getOrderInfo",
                "ORDER_NUM": this.onumber
            };
            this.myOrderService.serviceCall1(JSON.stringify(inputJson)).subscribe((response: any) => {
                this.orderdetail = JSON.parse(response._body);
                this.customerId = this.cookieService.getCookie('customerID') || this.orderdetail.CUSTOMER_ID;
                console.log(this.orderdetail)
                this.ins = this.orderdetail.SPECIAL_INSTRUCTIONS
                this.rush = this.orderdetail.RUSH
                this.dis_code = this.orderdetail.DISTANCE_CODE
                this.dis_code_options = this.orderdetail.DISTANCE_CODE_OPTIONS
                if (this.dis_code_options.length > 0) {
                    this.disSelected = true
                    for (let i = 0; i< this.dis_code_options.length; i++) {
                        const option = this.dis_code_options[i]["DISTANCE_CODE"]
                        if (this.dis_code_options[i]["SELECTED"] == "Y") {
                            this.disCodeOption.unshift(option)
                            this.input_dis_code = option
                        } else {
                            this.disCodeOption.push(option)
                        }
                    }
                }
                if (this.input_dis_code == '') {
                    this.disCodeOption.unshift("Select Distance Code")
                    this.disSelected = false
                }
                if (this.orderdetail.STATUS == 'N') {

                    if (this.orderdetail.MESSAGE == '') {
                        let result = this.orderdetail.ORDER_SUMMARY;
                        this.ngZone.run(() => {
                            let fp = $('#iframep');
                            fp.css('display', 'block');

                            let ifrm = $('#iframe1')[0];
                            ifrm = ifrm.contentWindow || ifrm.contentDocument.document || ifrm.contentDocument;
                            ifrm.document.open();
                            ifrm.document.write(result);
                            ifrm.document.close();
                            this.summaryData = result
                        })
                    }
                    else {
                        this.popup1(this.orderdetail)
                    }
                }
                else if (this.orderdetail.ORDER_GEOMETRY || this.orderdetail.ORDER_GEOMETRY.GEOMETRY_TYPE == undefined) {
                    let street = this.orderdetail.ADDRESS
                    let state = this.orderdetail.PROVSTATE
                    let country = this.orderdetail.COUNTRY
                    let city = this.orderdetail.CITY
                    let geocoder = new google.maps.Geocoder();

                    geocoder.geocode({ 'address': `${street} ${city} ${state} ${country}` }, (results, status) => {
                        if (status !== "ZERO_RESULTS") {
                            this.orderdetail.ORDER_GEOMETRY.CENTROID = [[[results[0].geometry.location.lng(), results[0].geometry.location.lat()]]]
                            this.orderdetail.ORDER_GEOMETRY.GEOMETRY = [[[results[0].geometry.location.lng(), results[0].geometry.location.lat()]]]

                            const data = {}
                            data["lng"] = results[0].geometry.location.lng();
                            data["lat"] = results[0].geometry.location.lat();
                            data["geometry"] = {}
                            data["geometry"]["geoData"] = [[[results[0].geometry.location.lng(), results[0].geometry.location.lat()]]]
                            data["geometry"]["lng"] = results[0].geometry.location.lng()
                            data["geometry"]["lat"] = results[0].geometry.location.lat()
                            data["GEOMETRY_TYPE"] = 'POINT'
                            data["PROVSTATE"] = this.orderdetail.PROVSTATE
                            data["COUNTRY"] = this.orderdetail.COUNTRY
                            data["ADDRESS"] = this.orderdetail.ADDRESS
                            data["CITY"] = this.orderdetail.CITY
                            data["POSTALZIP"] = this.orderdetail.POSTALZIP
                            this.mapinit(data)
                        }
                        else {
                            geocoder.geocode({ 'address': `${state} ${country}` }, results => {
                                results = JSON.parse(JSON.stringify(results));
                                this.orderdetail.ORDER_GEOMETRY.CENTROID = [[[results[0].geometry.location.lng(), results[0].geometry.location.lat()]]]
                                this.orderdetail.ORDER_GEOMETRY.GEOMETRY = [[[results[0].geometry.location.lng(), results[0].geometry.location.lat()]]]

                                const data = {}
                                data["lng"] = results[0].geometry.location.lng()
                                data["lat"] = results[0].geometry.location.lat()
                                data["geometry"] = {}
                                data["geometry"]["geoData"] = [[[results[0].geometry.location.lng(), results[0].geometry.location.lat()]]]
                                data["geometry"]["lng"] = results[0].geometry.location.lng()
                                data["geometry"]["lat"] = results[0].geometry.location.lat()
                                data["GEOMETRY_TYPE"] = 'POINT'
                                data["PROVSTATE"] = this.orderdetail.PROVSTATE
                                data["COUNTRY"] = this.orderdetail.COUNTRY
                                data["ADDRESS"] = this.orderdetail.ADDRESS
                                data["CITY"] = this.orderdetail.CITY
                                data["POSTALZIP"] = this.orderdetail.POSTALZIP
                                this.mapinit(data)
                            })
                        }
                    })
                }
                else {
                    const data = {}
                    data["lng"] = JSON.parse(this.orderdetail.ORDER_GEOMETRY.CENTROID)[0][0][0]
                    data["lat"] = JSON.parse(this.orderdetail.ORDER_GEOMETRY.CENTROID)[0][0][1]
                    data["geometry"] = {}
                    data["geometry"]["geoData"] = JSON.parse(this.orderdetail.ORDER_GEOMETRY.GEOMETRY)
                    data["geometry"]["lng"] = JSON.parse(this.orderdetail.ORDER_GEOMETRY.GEOMETRY)[0][0][0]
                    data["geometry"]["lat"] = JSON.parse(this.orderdetail.ORDER_GEOMETRY.GEOMETRY)[0][0][1]
                    data["GEOMETRY_TYPE"] = this.orderdetail.ORDER_GEOMETRY.GEOMETRY_TYPE
                    data["PROVSTATE"] = this.orderdetail.PROVSTATE
                    data["COUNTRY"] = this.orderdetail.COUNTRY
                    data["ADDRESS"] = this.orderdetail.ADDRESS
                    data["CITY"] = this.orderdetail.CITY
                    data["POSTALZIP"] = this.orderdetail.POSTALZIP
                    this.mapinit(data)
                }
            })
        })
    }
    state2: any
    sss = false
    locateme() {

        let street = this.address
        let city = this.city
        let country = this.country
        let postzip = this.postalzip
        let state = this.provstate
        let geocoder = new google.maps.Geocoder();

        geocoder.geocode({ 'address': `${street} ${city} ${state} ${country} ${postzip}` }, (results) => {
            this.ngZone.run(() => {
                let response = results[0];
                let Country = response.address_components.filter(item => {
                    return item.types[0] == 'country'
                })
                let s1 = Country[0]["long_name"]
                if (s1 == "Mexico" || s1 == "Canada") {
                    let state = response.address_components.filter(item => {
                        return item.types[0] == 'administrative_area_level_1'
                    })
                    this.state2 = state[0]["short_name"]
                    let postal_code = response.address_components.filter(item => {
                        return item.types[0] == 'postal_code'
                    })

                    let city = response.address_components.filter(item => {
                        return item.types[0] == 'locality'
                    })

                    let street_num = response.address_components.filter(item => {
                        return item.types[0] == 'street_number'
                    })
                    let route = response.address_components.filter(item => {
                        return item.types[0] == 'route'
                    })

                    this.statestat = false
                    this.statestat = false
                    const data = {}
                    data["lng"] = response.geometry.location.lng()
                    data["lat"] = response.geometry.location.lat()
                    data["geometry"] = {}
                    data["geometry"]["lng"] = response.geometry.location.lng()
                    data["geometry"]["lat"] = response.geometry.location.lat()
                    data["GEOMETRY_TYPE"] = 'POINT'
                    data["PROVSTATE"] = this.orderdetail.PROVSTATE
                    data["COUNTRY"] = this.orderdetail.COUNTRY
                    data["ADDRESS"] = this.address
                    data["CITY"] = city[0]["short_name"]
                    data["POSTALZIP"] = postal_code[0]["short_name"]
                    this.sss = true
                    this.mapinit(data)
                }
                else {

                    let state = response.address_components.filter(item => {
                        return item.types[0] == 'administrative_area_level_1'
                    })
                    this.state2 = state[0]["short_name"]
                    let postal_code = response.address_components.filter(item => {
                        return item.types[0] == 'postal_code'
                    })

                    let city = response.address_components.filter(item => {
                        return item.types[0] == 'locality'
                    })

                    let street_num = response.address_components.filter(item => {
                        return item.types[0] == 'street_number'
                    })
                    let route = response.address_components.filter(item => {
                        return item.types[0] == 'route'
                    })
                    if (city.length <= 1) {
                        city = response.address_components.filter(item => {
                            return item.types[0] == 'administrative_area_level_3'
                        })
                    }

                    if (this.state2 === this.provstate) {
                        this.statestat = false
                        const data = {}
                        data["lng"] = response.geometry.location.lng()
                        data["lat"] = response.geometry.location.lat()
                        data["geometry"] = {}
                        data["geometry"]["lng"] = response.geometry.location.lng()
                        data["geometry"]["lat"] = response.geometry.location.lat()
                        data["GEOMETRY_TYPE"] = 'POINT'
                        data["PROVSTATE"] = this.orderdetail.PROVSTATE
                        data["COUNTRY"] = this.orderdetail.COUNTRY
                        data["ADDRESS"] = this.address
                        data["CITY"] = city[0]["short_name"]
                        data["POSTALZIP"] = postal_code[0]["short_name"]
                        this.mapinit(data)
                    } else {
                        this.statestat = true
                    }
                }
            })
        })
    }
    statestat = false
    // >>>>>>>>>>> Mapinit
    mapinit(locatemeData) {
        this.isLoading = false
        ///>>>>>> MapStart
        let map;
        let drawingMode;
        let drawingManager;
        let parcelLayer;
        let savedGeoLayer;
        let totalPoly = [];
        let chosenGeo = [];
        let searchmarker;
        let parcelOn = false;
        let totalRequested = 0;
        let totalOverlay = [];
        let selectedOverlay;
        let selectedShape;
        let infoWindow = null;
        let parcelInfoWindow = null;
        let mapFeatures = [];
        let polyIw;

        let myShape;
        let allPoly = [];
        let xmax, xmin, ymax, ymin;
        let searchIw;
        let icon = {
            url: "assets/images/Site_Marker.png",
            scaledSize: new google.maps.Size(60, 40), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(30, 40)
        };

        this.orderdetail.ORDER_GEOMETRY.CENTROID = [[[locatemeData.lng, locatemeData.lat]]];
        this.orderdetail.ORDER_GEOMETRY.GEOMETRY = locatemeData.geometry.geoData ? locatemeData.geometry.geoData : [[[locatemeData.geometry.lng, locatemeData.geometry.lat]]];
        this.onHoldType = locatemeData.GEOMETRY_TYPE;
        this.centroid = this.orderdetail.ORDER_GEOMETRY.CENTROID;
        this.onHoldGeom = this.orderdetail.ORDER_GEOMETRY.GEOMETRY;
        this.provstate = locatemeData.PROVSTATE;
        this.country = locatemeData.COUNTRY;
        this.address = locatemeData.ADDRESS;
        this.city = locatemeData.CITY;
        this.postalzip = locatemeData.POSTALZIP;
        this.site_name = this.orderdetail.SITE_NAME;
        this.alternate_email = this.orderdetail.ALTERNATE_EMAIL;
        this.project_num = this.orderdetail.PROJECT_NUM;
        let that = this;

        if (this.sss) {
            this.Zoom = 12
        }
        else {
            if (this.geostat == "ZERO_RESULTS") {
                this.Zoom = 6
            }
            else if (this.address == "") {
                if (this.city != "") {
                    let geom = this.onHoldGeom[0][0];

                    let Center = { "lat": geom[0], "lng": geom[1] }
                    this.Zoom = 12
                    const mar = new google.maps.Marker({
                        position: Center,
                        icon: icon,
                        map,
                    });
                }
                else {
                    this.Zoom = 6
                }
            }
            else {
                this.Zoom = 17;
            }
        }
        let geom = this.onHoldGeom[0][0];
        let Center = new google.maps.LatLng(geom[1], geom[0]);
        let el = document.getElementById("updateMap");
        let mapOp = {
            center: Center,
            zoom: this.Zoom,
            fullscreenControl: false,
            streetViewControl: false,
            zoomControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT,
            },
        };

        map = new google.maps.Map(el, mapOp);

        const inputOrg = document.getElementById("pac-input") as HTMLInputElement;
        const input = inputOrg.cloneNode(true) as HTMLElement;
        input.style.display = "block";
        const searchBox = new google.maps.places.SearchBox(input);
        map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

        // Bias the SearchBox results towards current map's viewport.
        map.addListener("bounds_changed", () => {
            searchBox.setBounds(map.getBounds() as google.maps.LatLngBounds);
        });

        searchBox.addListener("places_changed", () => {
            const places = searchBox.getPlaces();

            if (places.length == 0) {
                return;
            }

            const bounds = new google.maps.LatLngBounds();
            places.forEach((place) => {
                if (!place.geometry || !place.geometry.location) {
                    console.log("Returned place contains no geometry");
                    return;
                }
                {
                    savedGeoLayer = new google.maps.Marker({
                        position: place.geometry.location,
                        icon: icon,
                        anchorPoint: new google.maps.Point(0, -25),
                        map: map,
                    });
                }

                if (place.geometry.viewport) {
                    // Only geocodes have viewport.
                    bounds.union(place.geometry.viewport);
                } else {
                    bounds.extend(place.geometry.location);
                }
            });

            map.fitBounds(bounds);
        })
        this.isLoading = true
        let range = new google.maps.Polygon({
            paths: this.onHoldBound,
            strokeColor: 'rgb(195,212,47)',
            strokeOpacity: 1,
            strokeWeight: 2,
            fillColor: 'rgb(195,212,47)',
            fillOpacity: 0,
            clickable: false,
            map: map
        });

        if ((that.onHoldGeom) && (that.onHoldType)) {
            that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(that.onHoldGeom));
            that.cookieService.setCookieSession("modifyType", that.onHoldType);
            that.cookieService.setCookieSession("parceIds", []);
            that.cookieService.setCookieSession("parIdArray", []);
            let savedGeoType = this.onHoldType;
            let Geom = this.onHoldGeom;

            if (Geom.length > 0) {
                let savedGeom = Geom[0];
                let savedGeom1 = [];
                for (let i = 0; i < savedGeom.length; i++) {
                    let pointJson = { lat: savedGeom[i][1], lng: savedGeom[i][0] };
                    savedGeom1.push(pointJson);
                }

                if (savedGeoType == "POLYGON") {
                    savedGeoLayer = new google.maps.Polygon({
                        paths: savedGeom1,
                        strokeColor: '#000',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: 'rgb(195,212,47)',
                        fillOpacity: 0.65,
                        map: map
                    });
                } else if (savedGeoType == "POLYLINE") {
                    savedGeoLayer = new google.maps.Polyline({
                        path: savedGeom1,
                        geodesic: true,
                        strokeColor: '#000',
                        strokeOpacity: 1.0,
                        strokeWeight: 2,
                        map: map
                    });
                } else if (savedGeoType == "POINT") {
                    savedGeoLayer = new google.maps.Marker({
                        position: savedGeom1[0],
                        icon: icon,
                        anchorPoint: new google.maps.Point(0, -25),
                        map: map,
                    });
                }
            }
            google.maps.event.addListener(map, 'zoom_changed', function (event) { //zoom change here
                let currentZoom = map.getZoom();
                that.cookieService.setCookieSession("homeZome", JSON.stringify(currentZoom));

                if ((currentZoom >= 17) && (parcelOn)) {
                    REP.Layer.Google.Initialize(map);	//turn parcel layer on/off depending on how far the user zooms in/out
                }
                else {
                    if (parcelInfoWindow != null) parcelInfoWindow.close();
                    if (parcelLayer) {
                        parcelLayer.setMap(null);
                        parcelLayer = null;
                    }
                    for (let i = 0; i < mapFeatures.length; i++) mapFeatures[i].setMap(null);
                    //remove parcel tile
                    map.overlayMapTypes.clear();
                }
            })


            google.maps.event.addListener(map, 'dblclick', function (event) {
                map.set("disableDoubleClickZoom", true);
                if ((parcelOn) && (map.getZoom()) >= 17) {
                    let chosenPoly = [];
                    if (map.getZoom() < REP.Layer.Google.MIN_ZOOM) return;

                    // Close any previous InfoWindow and hide any previous features.
                    if (parcelInfoWindow != null) parcelInfoWindow.close();
                    if (searchIw) { searchIw.close(); }

                    parcelInfoWindow = null;
                    for (let i = 0; i < mapFeatures.length; i++) mapFeatures[i].setMap(null);
                    mapFeatures = [];

                    let latLng = event.latLng;
                    if (totalRequested > 24) {
                        let wInfo = 'Your parcel request exceed limit (25)!'
                        parcelInfoWindow = new google.maps.InfoWindow({ position: latLng, content: wInfo });
                        parcelInfoWindow.open(map);
                        return
                    }

                    REP.Layer.Google.IdentifyByPoint(map, latLng, function (resp) {
                        let selectedGeom: any;
                        let extraOp = '';
                        let chosenGeo = '';
                        REP.Layer.IdentifyByPoint(map, latLng.lng(), latLng.lat(), function (respJson) {
                            for (let i = 0; i < respJson.results.length; i++) {
                                let respRowI = respJson.results[i];
                                if (typeof (respRowI['geom_as_wkt']) !== 'undefined') {
                                    selectedGeom = respRowI['geom_as_wkt'];
                                }
                            }
                            let parId = '';
                            let wText = '';
                            if (resp.results.length) {
                                totalRequested++;
                                let respRow0 = resp.results[0];
                                for (let respKey in respRow0) {
                                    let respVal = respRow0[respKey];
                                    if (respVal === null) continue;
                                    if (respKey === 'geom') {
                                        chosenGeo = respVal;
                                        for (let i = 0; i < respVal.length; i++) {
                                            respVal[i].setOptions({ fillColor: 'rgb(195,212,47)', fillOpacity: 0.65, strokeColor: 'rgb(195,212,47)', clickable: false });
                                            respVal[i].setMap(map);
                                            chosenPoly.push(respVal[i]);
                                        }
                                        mapFeatures = respVal;
                                    } else {
                                        parId = respRow0['parcel_id'];
                                        if (parId == null) {
                                            parId = "";
                                        }
                                        let addrNo = respRow0['addr_number'];
                                        if (addrNo == null) {
                                            addrNo = "";
                                        }
                                        let addrStreet = respRow0['addr_street_name'];
                                        if (addrStreet == null) {
                                            addrStreet = "";
                                        }
                                        let addrType = respRow0['addr_street_type'];
                                        if (addrType == null) {
                                            addrType = "";
                                        }
                                        let addrCity = respRow0['muni_name'];
                                        if (addrCity == null) {
                                            addrCity = "";
                                        }
                                        let addrState = respRow0['state_abbr'];
                                        if (addrState == null) {
                                            addrState = "";
                                        }
                                        let addrZip = respRow0['census_zip'];
                                        if (addrZip == null) {
                                            addrZip = "";
                                        }
                                        let addInfo = addrNo + " " + addrStreet + " " + addrType + " " + addrCity + " " + addrState + " " + addrZip;
                                        let countryInfo = respRow0['county_name'];// => County
                                        if (countryInfo == null) {
                                            countryInfo = "";
                                        }
                                        let ownerInfo = respRow0['owner'];//Owner
                                        if (ownerInfo == null) {
                                            ownerInfo = "";
                                        }
                                        let landUseInfo = respRow0['land_use_class'];
                                        if (landUseInfo == null) {
                                            landUseInfo = "";
                                        }
                                        let acreInfo = respRow0['acreage_calc'];//    bldg.sqft => Lot size
                                        if (acreInfo == null) {
                                            acreInfo = "";
                                        }
                                        wText = "<div style='marginTop:10px'><strong>Parcel ID: </strong>" + parId + "<br>" + "<strong>Address: </strong>" + addInfo + "<br>" + "<strong>County: </strong>" + countryInfo + '<br>' + "<strong>Owner: </strong>" + ownerInfo + '<br>' + "<strong>Land use class: </strong>" + landUseInfo + '<br>' + "<strong>Acreage: </strong>" + acreInfo + " acres</div>";
                                    }
                                }
                                let geocoder = new google.maps.Geocoder();
                                if (selectedGeom) {
                                    let g = selectedGeom.slice(15, -3);
                                }
                                if (chosenPoly.length == 1) {
                                    extraOp = '';
                                }

                                wText += '<hr style="margin:8px 0">' + extraOp + '<div align="center" class="mt-sm-2"><i id="geomBtn" class="fa fa-check btn btn-sm btn-outline-success mr-3" title="Select New Geometry"(click)="setGeom(\'' + chosenGeo + '\'' + ',' + '\'' + map + '\')"></i>' +
                                    '<i id="addGeomBtn" class="fa fa-plus btn btn-sm btn-outline-success mr-3" style=""(click)="addGeom(\'' + chosenGeo + '\'' + ',' + '\'' + map + '\')" title="Add Geometry"></i>' +//
                                    '<i id="clearGeomBtn" class="fa fa-cut btn btn-sm btn-outline-success mr-3" title="Clear Geometry" (click)="clearGeom(\'' + chosenGeo + '\'' + ',' + '\'' + map + '\')"></i></div><p id="parcelWarn" style="color:brown"></p>';

                                parcelInfoWindow = new google.maps.InfoWindow({ position: latLng, content: '<div style=\"width:225px; height:225px\">' + wText + "</div>" });
                                parcelInfoWindow.open(map);
                                google.maps.event.addListener(parcelInfoWindow, 'domready', function () {
                                    if (totalPoly.length == 0) {
                                        $("#addGeomBtn").addClass('disabled');
                                        $("#clearGeomBtn").addClass('disabled');
                                    } else if (totalPoly.length == 1) {
                                        $("#clearGeomBtn").addClass('disabled');
                                    }
                                    let btnparIdArray = [];
                                    let parceIds = [];
                                    if (that.cookieService.getCookie("parIdArray")) {
                                        btnparIdArray = JSON.parse(that.cookieService.getCookie("parIdArray"));
                                    }
                                    if (that.cookieService.getCookie("parceIds")) {
                                        parceIds = JSON.parse(that.cookieService.getCookie("parceIds"));
                                    }
                                    if (selectedGeom) {
                                        let btnabc: string;
                                        if (selectedGeom.substring(0, 12) == "MULTIPOLYGON") {
                                            btnabc = selectedGeom.slice(15, -3);
                                        } else if (selectedGeom.substring(0, 7) == "POLYGON") {
                                            btnabc = selectedGeom.slice(9, -3);
                                        }
                                        let btnres1 = btnabc.substring(0, 80);
                                        let btnres2 = btnabc.substring(btnabc.length - 80, btnabc.length);
                                        let btnselectedId = btnres1 + btnres2;
                                        let btnindex = btnparIdArray.indexOf(btnselectedId);
                                        if (btnindex == -1) {
                                            $("#clearGeomBtn").addClass('disabled');
                                        } else {
                                            $("#addGeomBtn").addClass('disabled');
                                        }
                                    }

                                    document.getElementById("geomBtn").onclick = function () {
                                        let parIdArray = [];
                                        let parceIds = [];

                                        if (savedGeoLayer) { savedGeoLayer.setMap(null) }

                                        for (let i = 0; i < allPoly.length; i++) {
                                            allPoly[i].setMap(null);
                                        }

                                        allPoly = [];

                                        for (let i = 0; i < totalPoly.length; i++) {
                                            totalPoly[i].setMap(null);
                                        }
                                        totalPoly = [];

                                        if (polyIw) polyIw.close();

                                        that.cookieService.deleteCookie("modifyGeometry");
                                        that.cookieService.deleteCookie("modifyType");

                                        if (parcelLayer) {
                                            parcelLayer.setMap(null);
                                            parcelLayer = null;
                                            if (parcelInfoWindow != null) parcelInfoWindow.close();
                                        }

                                        for (let geoLayer of that.savedMultiGeoLayer) {
                                            geoLayer.setMap(null)
                                        }
                                        for (let i = 0; i < totalOverlay.length; i++) {
                                            totalOverlay[i].overlay.setMap(null);
                                        }
                                        totalOverlay = [];
                                        for (let i = 0; i < totalPoly.length; i++) {
                                            totalPoly[i].setMap(null);
                                        }

                                        totalPoly = [];
                                        let geoIndex = $("#geoSel").val();
                                        if (geoIndex) {
                                            for (let i = 0; i < chosenPoly.length; i++) {
                                                chosenPoly[i].setMap(null);
                                                mapFeatures.pop();
                                            }
                                            chosenPoly[geoIndex - 1].setOptions({ fillColor: 'rgb(195,212,47)', fillOpacity: 0.65, strokeColor: '#000' });
                                            chosenPoly[geoIndex - 1].setMap(map);
                                            totalPoly.push(chosenPoly[geoIndex - 1]);
                                        }

                                        else {
                                            for (let i = 0; i < chosenPoly.length; i++) {
                                                chosenPoly[i].setOptions({ fillColor: 'rgb(195,212,47)', fillOpacity: 0.65, strokeColor: '#000' });
                                                chosenPoly[i].setMap(map);
                                                totalPoly.push(chosenPoly[i]);
                                            }
                                            mapFeatures.pop();
                                        }

                                        let Geom = [];
                                        if (selectedGeom) {
                                            let abc: string;
                                            if (selectedGeom.substring(0, 12) == "MULTIPOLYGON") {
                                                abc = selectedGeom.slice(15, -3);
                                            }

                                            else if (selectedGeom.substring(0, 7) == "POLYGON") {
                                                abc = selectedGeom.slice(9, -3);
                                            }
                                            let res1 = abc.substring(0, 80);
                                            let res2 = abc.substring(abc.length - 80, abc.length);
                                            let selectedId = res1 + res2;
                                            parIdArray.push(selectedId);

                                            if (parId) {
                                                parceIds.push(parId);
                                            }

                                            if ((abc.indexOf("),(") != -1) || (abc.indexOf(")),((") != -1)) {
                                                let sessionKey = that.cookieService.getCookie("sessionKey");
                                                let customerId = that.customerId;

                                                let multiReturn = [];

                                                if (abc.indexOf(")),((") != -1) {
                                                    multiReturn = abc.split(")),((");
                                                }

                                                else if (abc.indexOf("),(") != -1) {
                                                    multiReturn = abc.split("),(");
                                                }

                                                if (geoIndex) {
                                                    abc = multiReturn[geoIndex - 1];
                                                }

                                                else {
                                                    abc = multiReturn[0];
                                                }

                                                let cde = abc.split(/[ ,]+/);
                                                let gPoint = [];
                                                let gPoly = [];

                                                for (let i = 0; i < cde.length - 1; i += 2) {
                                                    gPoint = [parseFloat(cde[i]), parseFloat(cde[i + 1])];
                                                    gPoly.push(gPoint);
                                                }
                                                Geom.push(gPoly);
                                                geocoder.geocode({ 'address': cde[1] + ',' + cde[0] }, function (results) {
                                                    if (results.length == 0) {
                                                        return;
                                                    }

                                                    for (let i = 0; i < results.length; i++) {
                                                        if (results[i].geometry.location_type == "ROOFTOP") {
                                                            results[0] = results[i];
                                                            break
                                                        }
                                                    }


                                                    let country = "", ProvState = "", City = "";
                                                    let address = results[0].formatted_address;
                                                    let addressArray = address.split(',');
                                                    City = addressArray[1].trim();

                                                    for (let i = 0; i < results[0].address_components.length; i++) {
                                                        if (results[0].address_components[i].types.indexOf("country") != -1) {
                                                            country = results[0].address_components[i] && results[0].address_components[i].long_name;
                                                            if ((country != "United States") && (country != "Germany") && (country != "Canada") && (country != "Mexico") && (country != "United Kingdom") && (country != "Australia")) {
                                                                alert("no eris products available at this area!");
                                                                return;
                                                            }
                                                            let precountry = that.cookieService.getCookie("country");
                                                            if (precountry == "USA") precountry = 'United States';
                                                            if (precountry == "CAN") precountry = 'Canada';
                                                            if (precountry == "MEX") precountry = 'Mexico';
                                                            if (precountry == "UK") precountry = 'United Kingdom';
                                                            if (precountry == "AUS") precountry = 'Australia';
                                                            if (precountry == "GER") precountry = 'Germany';

                                                            if ((country != precountry) && (precountry)) {
                                                                that.cookieService.clearPre();
                                                            }
                                                        }

                                                        if (results[0].address_components[i].types.indexOf("administrative_area_level_1") != -1) {
                                                            ProvState = results[0].address_components[i] && results[0].address_components[i].short_name;
                                                            let preProvState = that.cookieService.getCookie("ProvState");

                                                            if ((ProvState != preProvState) && (preProvState)) {
                                                                that.cookieService.clearPre();
                                                            }
                                                        }

                                                        if (((results[0].address_components[i].types).indexOf("locality") != -1) && (country = "Germany")) {
                                                            City = results[0].address_components[i] && results[0].address_components[i].long_name;
                                                        }

                                                        that.cookieService.setCookieSession("address1", City + " , " + ProvState + " , " + country);
                                                        that.cookieService.setCookieSession("City1", City);

                                                        that.cookieService.setCookieSession("country1", country);

                                                        that.cookieService.setCookieSession("ProvState1", ProvState);
                                                    }
                                                })

                                                that.cookieService.setCookieSession("modifyType", "polygon");
                                                that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(Geom));
                                                that.cookieService.setCookieSession("parIdArray", JSON.stringify(parIdArray));
                                                that.cookieService.setCookieSession("parceIds", JSON.stringify(parceIds));
                                                let homezome = map.getZoom();
                                                that.cookieService.setCookieSession('homeZome', JSON.stringify(homezome));
                                                parcelInfoWindow.close();
                                            }

                                            else {

                                                let cde = abc.split(/[ ,]+/);

                                                geocoder.geocode({ 'address': cde[1] + ',' + cde[0] }, function (results) {

                                                    if (results.length == 0) {
                                                        return;
                                                    }

                                                    for (let i = 0; i < results.length; i++) {
                                                        if (results[i].geometry.location_type == "ROOFTOP") {
                                                            results[0] = results[i];
                                                            break
                                                        }
                                                    }

                                                    let country = "", ProvState = "", City = "";
                                                    let address = results[0].formatted_address;
                                                    let addressArray = address.split(',');
                                                    City = addressArray[1].trim();

                                                    for (let i = 0; i < results[0].address_components.length; i++) {
                                                        if (results[0].address_components[i].types.indexOf("country") != -1) {
                                                            country = results[0].address_components[i] && results[0].address_components[i].long_name;
                                                            if ((country != "United States") && (country != "Germany") && (country != "Canada") && (country != "Mexico") && (country != "United Kingdom") && (country != "Australia")) {
                                                                alert("no eris products available at this area!");
                                                                return;
                                                            }

                                                            let precountry = that.cookieService.getCookie("country");
                                                            if (precountry == "USA") precountry = 'United States';
                                                            if (precountry == "CAN") precountry = 'Canada';
                                                            if (precountry == "MEX") precountry = 'Mexico';
                                                            if (precountry == "UK") precountry = 'United Kingdom';
                                                            if (precountry == "AUS") precountry = 'Australia';
                                                            if (precountry == "GER") precountry = 'Germany';

                                                            if ((country != precountry) && (precountry)) {
                                                                that.cookieService.clearPre();
                                                            }
                                                        }
                                                        if (results[0].address_components[i].types.indexOf("administrative_area_level_1") != -1) {
                                                            ProvState = results[0].address_components[i] && results[0].address_components[i].short_name;
                                                            let preProvState = that.cookieService.getCookie("ProvState");
                                                            if ((ProvState != preProvState) && (preProvState)) {
                                                                that.cookieService.clearPre();
                                                            }
                                                        }
                                                        if (((results[0].address_components[i].types).indexOf("locality") != -1) && (country = "Germany")) {
                                                            City = results[0].address_components[i] && results[0].address_components[i].long_name;
                                                        }

                                                        that.cookieService.setCookieSession("address1", City + " , " + ProvState + " , " + country);
                                                        that.cookieService.setCookieSession("City1", City);
                                                        that.cookieService.setCookieSession("country1", country);
                                                        that.cookieService.setCookieSession("ProvState1", ProvState);
                                                    }
                                                });
                                                let gPoint = [];
                                                let gPoly = [];

                                                for (let i = 0; i < cde.length - 1; i += 2) {
                                                    gPoint = [parseFloat(cde[i]), parseFloat(cde[i + 1])];
                                                    gPoly.push(gPoint);
                                                }
                                                Geom.push(gPoly);

                                                that.cookieService.setCookieSession("modifyType", "polygon");
                                                that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(Geom));
                                                that.cookieService.setCookieSession("parIdArray", JSON.stringify(parIdArray));
                                                that.cookieService.setCookieSession("parceIds", JSON.stringify(parceIds));
                                                let homezome = map.getZoom();
                                                that.cookieService.setCookieSession('homeZome', JSON.stringify(homezome));
                                                parcelInfoWindow.close();
                                            }
                                        }
                                    }

                                    document.getElementById("addGeomBtn").onclick = function () {

                                        if (totalPoly.length < 1) {
                                            return;
                                        }
                                        let parIdArray = JSON.parse(that.cookieService.getCookie("parIdArray"));
                                        let parceIds = JSON.parse(that.cookieService.getCookie("parceIds"));
                                        if (parIdArray.length > 19) {
                                            $("#parcelWarn").text("Maximum parcel number is 20.");
                                            return
                                        }
                                        let multi: any;
                                        let sessionKey = that.cookieService.getCookie("sessionKey");
                                        let customerId = that.customerId;
                                        if (polyIw) polyIw.close();
                                        if (that.savedGeoLayer) { that.savedGeoLayer.setMap(null); }
                                        for (let geoLayer of that.savedMultiGeoLayer) {
                                            geoLayer.setMap(null)
                                        }
                                        for (let i = 0; i < totalOverlay.length; i++) {
                                            totalOverlay[i].overlay.setMap(null);
                                        }
                                        totalOverlay = [];
                                        let geoIndex = $("#geoSel").val();

                                        //============multiple process
                                        let Geom = [];
                                        let Geomed = JSON.parse(that.cookieService.getCookie("modifyGeometry"));
                                        let multiJson = [];
                                        for (let geom of Geomed) {
                                            multiJson.push(JSON.stringify([geom]));
                                        }

                                        //==========
                                        if (selectedGeom) {
                                            let abc: string;
                                            if (selectedGeom.substring(0, 12) == "MULTIPOLYGON") {
                                                abc = selectedGeom.slice(15, -3);
                                            } else if (selectedGeom.substring(0, 7) == "POLYGON") {
                                                abc = selectedGeom.slice(9, -3);
                                            }
                                            let res1 = abc.substring(0, 80);
                                            let res2 = abc.substring(abc.length - 80, abc.length);
                                            let selectedId = res1 + res2;

                                            if (parIdArray.indexOf(selectedId) != -1) {
                                                $("#parcelWarn").text("Selected Geometry is duplicated");
                                                return
                                            }
                                            parIdArray.push(selectedId);
                                            parceIds.push(parId);
                                            if ((abc.indexOf("),(") != -1) || (abc.indexOf(")),((") != -1)) {
                                                let sessionKey = that.cookieService.getCookie("sessionKey");
                                                let customerId = that.customerId;

                                                let multiReturn = [];
                                                if (abc.indexOf(")),((") != -1) {
                                                    multiReturn = abc.split(")),((");
                                                } else if (abc.indexOf("),(") != -1) {
                                                    multiReturn = abc.split("),(");
                                                }
                                                if (geoIndex) {
                                                    abc = multiReturn[geoIndex - 1];
                                                } else {
                                                    abc = multiReturn[0];
                                                }
                                            }

                                            let cde = abc.split(/[ ,]+/);

                                            let gPoint = [];
                                            let gPoly = [];

                                            for (let i = 0; i < cde.length - 1; i += 2) {
                                                gPoint = [parseFloat(cde[i]), parseFloat(cde[i + 1])];
                                                gPoly.push(gPoint);
                                            }
                                            Geom.push(gPoly);
                                            multiJson.push(JSON.stringify(Geom));
                                            let geoJson = { "GEOMETRY": multiJson }
                                            that.packageService.geomValidate(customerId, JSON.stringify(geoJson), sessionKey).subscribe(response => {
                                                multi = JSON.parse(response);
                                                let le = $('#geoSel').children('option').length;
                                                if (multi.SIZE != "N") {
                                                    if (geoIndex) {
                                                        let le = $('#geoSel').children('option').length;
                                                        for (let i = 0; i < le; i++) {
                                                            chosenPoly[i].setMap(null);
                                                            mapFeatures.pop();
                                                        }
                                                        chosenPoly[geoIndex - 1].setOptions({ fillColor: 'rgb(195,212,47)', fillOpacity: 0.65, strokeColor: '#000' });
                                                        chosenPoly[geoIndex - 1].setMap(map);
                                                        totalPoly.push(chosenPoly[geoIndex - 1]);
                                                    } else {
                                                        for (let i = 0; i < chosenPoly.length; i++) {
                                                            chosenPoly[i].setOptions({ fillColor: 'rgb(195,212,47)', fillOpacity: 0.65, strokeColor: '#000' });
                                                            chosenPoly[i].setMap(map);
                                                            totalPoly.push(chosenPoly[i]);
                                                        }
                                                        mapFeatures.pop();
                                                    }
                                                    Geomed.push(gPoly);
                                                    that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(Geomed));
                                                    that.cookieService.setCookieSession("parIdArray", JSON.stringify(parIdArray));
                                                    that.cookieService.setCookieSession("parceIds", JSON.stringify(parceIds));
                                                    let homezome = map.getZoom();
                                                    that.cookieService.setCookieSession('homeZome', JSON.stringify(homezome));
                                                    parcelInfoWindow.close();
                                                } else {
                                                    $("#parcelWarn").text("Selected Geometry must be adjacent.");
                                                }
                                            })
                                        }
                                    }

                                    document.getElementById("clearGeomBtn").onclick = function () {

                                        if (totalPoly.length > 1) {
                                            let multi: any;
                                            let Geomed = JSON.parse(that.cookieService.getCookie("modifyGeometry"));
                                            let multiJson = [];
                                            for (let geom of Geomed) {
                                                multiJson.push(JSON.stringify([geom]));
                                            }
                                            let parIdArray = JSON.parse(that.cookieService.getCookie("parIdArray"));
                                            let parceIds = JSON.parse(that.cookieService.getCookie("parceIds"));
                                            if (selectedGeom) {
                                                let abc: string;
                                                if (selectedGeom.substring(0, 12) == "MULTIPOLYGON") {
                                                    abc = selectedGeom.slice(15, -3);
                                                } else if (selectedGeom.substring(0, 7) == "POLYGON") {
                                                    abc = selectedGeom.slice(9, -3);
                                                }
                                                let res1 = abc.substring(0, 80);
                                                let res2 = abc.substring(abc.length - 80, abc.length);
                                                let selectedId = res1 + res2;
                                                let index = parIdArray.indexOf(selectedId);
                                                if (index != -1) {
                                                    multiJson.splice(index, 1);
                                                    let sessionKey = that.cookieService.getCookie("sessionKey");
                                                    let customerId = that.customerId;
                                                    let geoJson = { "GEOMETRY": multiJson }
                                                    that.packageService.geomValidate(customerId, JSON.stringify(geoJson), sessionKey).subscribe(response => {
                                                        multi = JSON.parse(response);

                                                        if (multi.SIZE != "N") {
                                                            parIdArray.splice(index, 1);
                                                            parceIds.splice(index, 1);
                                                            totalPoly[index].setMap(null);
                                                            totalPoly.splice(index, 1)
                                                            Geomed.splice(index, 1);
                                                            that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(Geomed));
                                                            that.cookieService.setCookieSession("parIdArray", JSON.stringify(parIdArray));
                                                            that.cookieService.setCookieSession("parceIds", JSON.stringify(parceIds));
                                                            let homezome = map.getZoom();
                                                            that.cookieService.setCookieSession('homeZome', JSON.stringify(homezome));
                                                            parcelInfoWindow.close();
                                                            for (let i = 0; i < mapFeatures.length; i++) mapFeatures[i].setMap(null);
                                                            mapFeatures = [];
                                                        } else {
                                                            $("#parcelWarn").text("Selected Geometry must be adjacent.");
                                                        }
                                                    })
                                                }
                                            }
                                        } else {
                                            $("#parcelWarn").text("Only one Geometry left.");
                                        }
                                    }
                                });
                                google.maps.event.addListener(parcelInfoWindow, 'closeclick', function () {
                                    for (let i = 0; i < mapFeatures.length; i++) mapFeatures[i].setMap(null);
                                    mapFeatures = [];
                                });
                            }
                        });
                    }, function (errObj) {
                        alert('REP Overlays error: ' + errObj.message);
                    });
                }
            });

            //draw geometry
            let toolbarDiv = document.getElementById('topToobar');
            if (this.call_count) {
                map.controls[google.maps.ControlPosition.TOP_RIGHT].push(toolbarDiv);
                this.call_count = false
            }
            let polyOptions = {
                strokeWeight: 2,
                strokeColor: '#000',
                fillColor: 'rgb(195,212,47)',
                fillOpacity: 0.65,
                editable: true,
            };

            drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: null,
                markerOptions: {
                    icon: icon,
                    anchorPoint: new google.maps.Point(0, -25),
                },
                polylineOptions: {
                    editable: true,
                    strokeWeight: 2,
                    strokeColor: '#000',
                },

                rectangleOptions: polyOptions,
                circleOptions: polyOptions,
                polygonOptions: polyOptions,
                map: map
            });
            drawingMode = 'hand';
            drawingManager.setOptions({
                drawingControl: false
            });


            google.maps.event.addListener(map, 'overlaycomplete', event => {
                if (event.type !== google.maps.drawing.OverlayType.MARKER) {
                    map.setDrawingMode(null);
                    google.maps.event.addListener(event.overlay, 'click', e => {
                        selectedOverlay = event.overlay;
                        selectedOverlay.setEditable(true);
                    });
                    selectedOverlay = event.overlay;
                }
            });

            google.maps.event.addListener(drawingManager, 'overlaycomplete', function (e) {
                if (polyIw) polyIw.close();
                if (savedGeoLayer) { savedGeoLayer.setMap(null); }
                for (let poly of allPoly) {
                    poly.setMap(null)
                }
                allPoly = [];

                for (let totPoly of totalPoly) {
                    totPoly.setMap(null)
                }
                totalPoly = [];

                if (myShape) {
                    allPoly = [];
                    allPoly.push(myShape);
                }
                let newShape = e.overlay;
                myShape = e.overlay;
                myShape.type = e.type;
                newShape.type = e.type;
                if (e.type !== google.maps.drawing.OverlayType.MARKER) {
                    // Switch back to non-drawing mode after drawing a shape.
                    drawingManager.setDrawingMode(null);
                    let compareResult = compareRange(myShape, newShape.type);
                    let modifiedGeom = compareResult[0];
                    if (compareResult[1]) {
                        if (myShape) {
                            myShape.setMap(null);;
                        } else {
                            alert("yo")
                        }

                        if (e.overlay) {
                            e.overlay.setMap(null);;
                        }
                        let type = newShape.type;
                        newShape.setMap(null);
                        //drawing a new shape based on modifiedGeom
                        if (type == "polygon") {
                            myShape = new google.maps.Polygon({
                                paths: modifiedGeom,
                                strokeColor: '#000',
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                fillColor: 'rgb(195,212,47)',
                                fillOpacity: 0.65,
                                editable: true,
                                map: map
                            });
                            google.maps.event.trigger(drawingManager, 'overlaycomplete', { type: "polygon", overlay: myShape });
                        } else if (type == "polyline") {
                            myShape = new google.maps.Polyline({
                                path: modifiedGeom,
                                geodesic: true,
                                strokeColor: '#000',
                                strokeOpacity: 1.0,
                                strokeWeight: 2,
                                editable: true,
                                map: map
                            });
                            google.maps.event.trigger(drawingManager, 'overlaycomplete', { type: "polyline", overlay: myShape });
                        }
                    } else {

                        myShape = e.overlay; allPoly.push(myShape);
                    }

                    for (let i = 0; i < totalPoly.length; i++) {
                        totalPoly[i].setMap(null);
                    }
                    totalPoly = [];

                    let gpoly = [];
                    let selectedGeometry = [];
                    calArea(compareResult[2], newShape.type);
                    gpoly = getPoly(compareResult[2]);

                    selectedGeometry.push(gpoly);
                    that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(selectedGeometry));
                    that.cookieService.setCookieSession("modifyType", newShape.type);
                    that.cookieService.setCookieSession("parceIds", []);
                    that.cookieService.setCookieSession("parIdArray", []);

                    //end reverse

                    gpoly = getPoly(compareResult[2]);
                    selectedGeometry.push(gpoly);
                    google.maps.event.addListener(myShape, 'click', function (e) {
                        if (e.vertex !== undefined) {
                            if (newShape.type === google.maps.drawing.OverlayType.POLYGON) {
                                let path = myShape.getPaths().getAt(e.path);
                                path.removeAt(e.vertex);
                                if (path.length < 3) {
                                    myShape.setMap(null);
                                    if (polyIw) {
                                        polyIw.close();
                                    }
                                }
                            }
                            if (newShape.type === google.maps.drawing.OverlayType.POLYLINE) {

                                let path = myShape.getPath();
                                path.removeAt(e.vertex);
                                if (path.length < 2) {
                                    myShape.setMap(null);
                                    if (polyIw) {
                                        polyIw.close();
                                    }
                                }
                            }
                        }
                        let compareResult = compareRange(myShape, newShape.type);
                        let modifiedGeom = compareResult[0];
                        if (compareResult[1]) {

                            let type = newShape.type;
                            if (myShape) {
                                myShape.setMap(null);;
                            }
                            newShape.setMap(null);
                            //drawing a new shape based on modifiedGeom
                            if (type == "polygon") {
                                myShape = new google.maps.Polygon({
                                    paths: modifiedGeom,
                                    strokeColor: '#000',
                                    strokeOpacity: 0.8,
                                    strokeWeight: 2,
                                    fillColor: 'rgb(195,212,47)',
                                    fillOpacity: 0.65,
                                    editable: true,
                                    map: map
                                });
                            } else if (type == "polyline") {
                                myShape = new google.maps.Polyline({
                                    path: modifiedGeom,
                                    geodesic: true,
                                    strokeColor: '#000',
                                    strokeOpacity: 1.0,
                                    strokeWeight: 2,
                                    editable: true,
                                    map: map
                                });
                            }
                        }

                        let gpoly = [];
                        let selectedGeometry = [];

                        calArea(compareResult[2], newShape.type);
                        gpoly = getPoly(compareResult[2]);

                        selectedGeometry.push(gpoly);

                        setSelection(newShape);
                        that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(selectedGeometry));
                        that.cookieService.setCookieSession("modifyType", newShape.type);
                    });

                    google.maps.event.addListener(myShape.getPath(), 'set_at', function (e) {
                        if (polyIw) polyIw.close();
                        if (e.vertex !== undefined) {
                            if (newShape.type === google.maps.drawing.OverlayType.POLYGON) {
                                let path = myShape.getPaths().getAt(e.path);
                                path.setAt(e.vertex);
                                if (path.length < 3) {
                                    myShape.setMap(null);
                                }
                            }
                            if (newShape.type === google.maps.drawing.OverlayType.POLYLINE) {

                                let path = myShape.getPath();
                                path.setAt(e.vertex);
                                if (path.length < 2) {
                                    myShape.setMap(null);
                                }
                            }
                        }
                        let compareResult = compareRange(myShape, newShape.type);
                        let modifiedGeom = compareResult[0];
                        if (compareResult[1]) {

                            let type = newShape.type;
                            if (myShape) {
                                myShape.setMap(null);;
                            }
                            newShape.setMap(null);
                            //drawing a new shape based on modifiedGeom
                            if (type == "polygon") {
                                myShape = new google.maps.Polygon({
                                    paths: modifiedGeom,
                                    strokeColor: '#000',
                                    strokeOpacity: 0.8,
                                    strokeWeight: 2,
                                    fillColor: 'rgb(195,212,47)',
                                    fillOpacity: 0.65,
                                    editable: true,
                                    map: map
                                });
                                google.maps.event.trigger(drawingManager, 'overlaycomplete', { type: "polygon", overlay: myShape });
                            } else if (type == "polyline") {
                                myShape = new google.maps.Polyline({
                                    path: modifiedGeom,
                                    geodesic: true,
                                    strokeColor: '#000',
                                    strokeOpacity: 1.0,
                                    strokeWeight: 2,
                                    editable: true,
                                    map: map
                                });
                                google.maps.event.trigger(drawingManager, 'overlaycomplete', { type: "polyline", overlay: myShape });
                            }
                        }

                        let gpoly = [];
                        let selectedGeometry = [];
                        calArea(compareResult[2], newShape.type);
                        gpoly = getPoly(compareResult[2]);

                        selectedGeometry.push(gpoly);
                        setSelection(newShape);
                        that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(selectedGeometry));
                        that.cookieService.setCookieSession("modifyType", newShape.type);
                    });

                    google.maps.event.addListener(myShape.getPath(), 'insert_at', function (e) {
                        if (e.vertex !== undefined) {
                            if (newShape.type === google.maps.drawing.OverlayType.POLYGON) {
                                let path = newShape.getPaths().getAt(e.path);
                                path.insertAt(e.vertex);
                                if (path.length < 3) {
                                    newShape.setMap(null);
                                }
                            }
                            if (newShape.type === google.maps.drawing.OverlayType.POLYLINE) {
                                let path = newShape.getPath();
                                path.insertAt(e.vertex);
                                if (path.length < 2) {
                                    newShape.setMap(null);
                                }
                            }
                        }
                        setSelection(newShape);

                        let compareResult = compareRange(newShape, newShape.type);
                        let modifiedGeom = compareResult[0];
                        if (compareResult[1]) {

                            let type = newShape.type;
                            if (myShape) {
                                myShape.setMap(null);;
                            }
                            newShape.setMap(null);
                            //drawing a new shape based on modifiedGeom
                            if (type == "polygon") {
                                myShape = new google.maps.Polygon({
                                    paths: modifiedGeom,
                                    strokeColor: '#000',
                                    strokeOpacity: 0.8,
                                    strokeWeight: 2,
                                    fillColor: 'rgb(195,212,47)',
                                    fillOpacity: 0.65,
                                    editable: true,
                                    map: map
                                });
                            } else if (type == "polyline") {
                                myShape = new google.maps.Polyline({
                                    path: modifiedGeom,
                                    geodesic: true,
                                    strokeColor: '#000',
                                    strokeOpacity: 1.0,
                                    strokeWeight: 2,
                                    editable: true,
                                    map: map
                                });
                            }
                            google.maps.event.trigger(drawingManager, 'overlaycomplete', { type: "polygon", overlay: myShape });
                        }

                        let gpoly = [];
                        let selectedGeometry = [];
                        calArea(compareResult[2], newShape.type);
                        gpoly = getPoly(compareResult[2]);

                        selectedGeometry.push(gpoly);

                        that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(selectedGeometry));
                        that.cookieService.setCookieSession("modifyType", newShape.type);
                    });
                } else {
                    myShape = e.overlay; allPoly.push(myShape);
                    let oriGeom = [];
                    let modifiedGeom = [];
                    let oripoint = { lat: e.overlay.position.lat(), lng: e.overlay.position.lng() };

                    oriGeom.push(oripoint);

                    let gpoly = [];
                    let selectedGeometry = [];
                    let gpoint = [e.overlay.position.lng(), e.overlay.position.lat()];

                    gpoly.push(gpoint);
                    selectedGeometry.push(gpoly);
                    that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(selectedGeometry));
                    that.cookieService.setCookieSession("modifyType", "POINT");
                    google.maps.event.addListener(newShape, 'click', function (e) {
                    });
                    setSelection(newShape);
                }
            });
            google.maps.event.addListener(drawingManager, 'drawingmode_changed', clearSelection);
        } else {
            // else clause
        }

        function setSelection(shape) {
            if (shape.type !== 'marker') {
                clearSelection();
                shape.setEditable(true);
            }
            selectedShape = shape;
        }

        function clearSelection() {
            if (selectedShape) {
                if (selectedShape.type !== 'marker') {
                    selectedShape.setEditable(false);
                }
                selectedShape = null;
            }
        }

        jQuery(function ($) {

            $('#button-delete').click(function () {
                $('#white-background').css('display', 'block');

                if (savedGeoLayer) { savedGeoLayer.setMap(null) }

                for (let i = 0; i < allPoly.length; i++) {
                    allPoly[i].setMap(null);
                }
                allPoly = [];

                for (let i = 0; i < totalPoly.length; i++) {
                    totalPoly[i].setMap(null);
                }
                totalPoly = [];

                if (polyIw) polyIw.close();
                that.cookieService.deleteCookie("modifyGeometry");
                that.cookieService.deleteCookie("modifyType");
            });
            $('#button-parcel').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingManager.setDrawingMode(null);
                parcelToggle();
            });

            $(document).ready(function () {

                parcelOn = true;
                REP.Layer.Google.Initialize(map);
            })

            $('#gmdm-hand').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingMode = 'hand';
                drawingManager.setDrawingMode(null);
                $('#gmdm-' + drawingMode).addClass('selected');
            });
            $('#gmdm-marker').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingMode = google.maps.drawing.OverlayType.MARKER;
                drawingManager.setDrawingMode(drawingMode);
                $('#gmdm-' + drawingMode).addClass('selected');
                if (polyIw) polyIw.close();
            });
            $('#gmdm-polyline').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingMode = google.maps.drawing.OverlayType.POLYLINE;
                drawingManager.setDrawingMode(drawingMode);
                $('#gmdm-' + drawingMode).addClass('selected');
                if (polyIw) polyIw.close();
            });

            $('#gmdm-polygon').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingMode = google.maps.drawing.OverlayType.POLYGON;
                drawingManager.setDrawingMode(drawingMode);
                $('#gmdm-' + drawingMode).addClass('selected');
                if (polyIw) polyIw.close();
            });
        })

        function compareRange(shape, type) {
            let modifiedGeom = [];
            let flag = false;
            for (let i = 0; i < shape.getPath().length; i++) {

                let glat = shape.getPath().getAt(i).lat();
                let glng = shape.getPath().getAt(i).lng();
                let gpoint = { lat: shape.getPath().getAt(i).lat(), lng: shape.getPath().getAt(i).lng() };
                modifiedGeom.push(gpoint);//
            }

            if (modifiedGeom.length > 0) {
                for (let geom of modifiedGeom) {

                    if (geom.lat > xmax) {
                        geom.lat = xmax - 0.000000000001;
                        flag = true;
                    }
                    if (geom.lat < xmin) {
                        geom.lat = xmin + 0.00000000000001;
                        flag = true;
                    }
                    if (geom.lng > ymax) {
                        geom.lng = ymax - 0.0000000001;
                        flag = true;
                    }
                    if (geom.lng < ymin) {
                        geom.lng = ymin + 0.000000000001;
                        flag = true;
                    }
                }
            }
            let paths = [];
            for (let point of modifiedGeom) {
                let path = new google.maps.LatLng(point.lat, point.lng)
                paths.push(path);
            }

            return [modifiedGeom, flag, paths];
        }

        function calArea(path, type) {
            let Content, geomArea;
            if (type == "polygon") {
                geomArea = Math.round(google.maps.geometry.spherical.computeArea(path) * 0.00024711);
                Content = "<strong>Polygon area</strong>" + "<hr style='margin:2px; padding:0'>" + geomArea + " acres";
            } else if (type == "polyline") {
                geomArea = Math.round(google.maps.geometry.spherical.computeLength(path));
                Content = "<strong>Line length</strong>" + "<hr style='margin:2px; padding:0'>" + geomArea + " meters"
            }
            //return Content
            if (geomArea > 0) {
                if (polyIw) {
                    polyIw.close();
                }
                let polyIndex = Math.ceil(((path).length) / 2);
                let lat = path[polyIndex].lat();
                let lng = path[polyIndex].lng();
                let iwPostion = { lat, lng };

                polyIw = new google.maps.InfoWindow({
                    position: iwPostion,
                    content: '<div style=\"width:150px; height:50px\">' + Content + "</div>",
                });
                polyIw.open(map);
            }
        }

        function getPoly(path) {
            let gpoly = [];
            for (let i = 0; i < path.length; i++) {
                let glat = path[i].lat();
                let glng = path[i].lng();
                let gpoint = [path[i].lng(), path[i].lat()];
                gpoly.push(gpoint);
            }
            return gpoly
        }

        function parcelToggle() {

            if (parcelOn) {
                parcelOn = false;
                if (parcelInfoWindow !== null) parcelInfoWindow.close();
                for (let i = 0; i < mapFeatures.length; i++) mapFeatures[i].setMap(null);
                //remove parcel tile
                map.overlayMapTypes.clear();
            } else {
                parcelOn = true;
                REP.Layer.Google.Initialize(map);
            }
        }
        this.isLoading = true
    }

    input_dis_code = ""
    disSelected = false
    disCodeOption = []
    changeDisCode(event) {
        if (event.target.checked) {
            this.input_dis_code = this.disCodeOption[0]
            this.disSelected = true

        } else {
            this.disSelected = false
            this.input_dis_code = ""
        }
    }

    onSelectDisCode(option){
        this.input_dis_code = option
    }

    changeRush(event) {
        if (event.target.checked) {
            this.orderdetail.RUSH = "Y"
        }
        else {
            this.orderdetail.RUSH = "N"
        }
    }

    /// >>>>>>>>>> Save
    savedata() {

        if ((this.cookieService.getCookie("modifyGeometry")) && (this.cookieService.getCookie("modifyType"))) {

            this.onHoldGeom = this.cookieService.getCookie("modifyGeometry");
            this.onHoldType = this.cookieService.getCookie("modifyType");
            let parcelIds = this.cookieService.getCookie("parceIds");
            let parIdarrary = this.cookieService.getCookie("parIdArray")
            if (this.onHoldType == "polygon") {
                if ((parcelIds.length == 0 && parIdarrary.length == 0)) {
                    let geomArray = JSON.parse(this.onHoldGeom)
                    geomArray[0].push(geomArray[0][0]);
                    this.onHoldGeom = JSON.stringify(geomArray);
                }
            }
        }
        else if (!(this.cookieService.getCookie("modifyGeometry")) && !(this.cookieService.getCookie("modifyType"))) {
            this.onHoldGeom = ''
        }

        let InputJson = {
            "PROCEDURE": "updateOrder",
            "ORDER_NUM": this.onumber,
            "SITE_NAME": this.site_name,
            "DISTANCE_CODE": this.input_dis_code,
            "PROJECT_NUM": this.project_num,
            "ADDRESS": this.address,
            "CITY": this.city,
            "PROVSTATE": this.provstate,
            "POSTALZIP": this.postalzip,
            "COUNTRY": this.country,
            "ALTERNATE_EMAIL": this.alternate_email,
            "RUSH": this.orderdetail.RUSH,
            "SPECIAL_INSTRUCTIONS": this.ins,
            "ORDER_GEOMETRY": {
                "GEOMETRY_TYPE": this.onHoldType,
                "GEOMETRY": this.onHoldGeom,
                "CENTROID": this.centroid
            }
        }

        let newArray = this.onHoldGeom.slice(3, -3).split(',');
        {
            if (this.onHoldType.toUpperCase() == "POLYGON" && newArray.length >= 6 || this.onHoldType.toUpperCase() == "POLYLINE" && newArray.length >= 4 || this.onHoldType.toUpperCase() == "POINT" && newArray.length == 2) {
                if (this.onHoldGeom.length != 0) {
                    this.myOrderService.serviceCall1(JSON.stringify(InputJson)).subscribe((response: any) => {
                        let data = JSON.parse(response._body)
                        this.geos = false
                        this.stat = true;
                        this.yes = true
                        if (data.STATUS == 'Y') {
                            this.statuscheck = true
                            this.successmsg = data.MESSAGE
                            this.pdf()
                        } else {
                            this.statuscheck1 = true
                            this.errormsg1 = data.MESSAGE
                            this.disable1 = true
                        }
                    })
                    if (!this.yes) {
                        this.validationInfo = "Geometry need to be within State"
                        this.disable1 = true
                    }
                } else {
                    this.geos = true
                    this.validationInfo = "Your geometry is invalid!"
                    this.disable1 = true
                }
            } else {
                this.geos = true
                this.validationInfo = "Your geometry is invalid!"
                this.disable1 = true
            }
        }
    }

    statuscheck1 = false
    statuscheck = false
    errormsg1: any
    geos = false
    successmsg: any
    confirm_check = false
    check_msg_error = false
    stat = false;
    private isButtonVisible = false;

    check() {
        if (this.confirm_check) {
            this.check_msg_error = false
        }
    }

    summaryData
    disable1 = true;
    distanceCodeError = false

    disable() {
        if (this.input_dis_code != "Select Distance Code" && !this.distanceCodeError) {
            this.disable1 = false
            this.limstate()
        } else {
            let select = document.getElementById('options') as HTMLElement

            setTimeout(() => {
                this.distanceCodeError = false
                select.style.border = ''
            }, 3000)
            this.distanceCodeError = true
            select.style.border ='2px solid red'
        }

    }

    closeModal1() {
        this.statuscheck = false
    }

    pdf() {
        let input = {
            "PROCEDURE": "getordersummary",
            "ORDER_NUM": this.onumber
        }
        this.myOrderService.serviceCall1(JSON.stringify(input)).subscribe((response: any) => {
            let result = response._body
            this.ngZone.run(() => {
                let fp = $('#iframep');
                fp.css('display', 'block');
                let ifrm = $('#iframe1')[0];
                ifrm = ifrm.contentWindow || ifrm.contentDocument.document || ifrm.contentDocument;
                ifrm.document.open();
                ifrm.document.write(result);
                ifrm.document.close();
                this.summaryData = result
            })
        })
    }

    popup1(data) {
        this.popup = true
        this.errormsg = data.MESSAGE
        $('#resModal').modal({
            backdrop: 'static',
            keyboard: false  // to prevent closing with Esc button (if you want this too)
        });
        $("#resModal").modal("show");
    }

    toggle = false;
    status1 = 'Enable';

    enableDisableRule() {
        this.toggle = !this.toggle;
    }
}
